// Lightweight shared configuration and response helpers. Importing these never loads the API client or routing switches.
export const V2_API = process.env.NEXT_PUBLIC_AI_APP_API

/** Request metadata for existing screen adapters; the v2 client supplies its own Bearer authentication. */
export const signedIn = (
  token: string,
  headers: Record<string, string> = {},
): Record<string, string> => ({ ...headers, Authorization: token })

/** JSON request metadata for the adapter interface. */
export const signedInJson = (token: string) =>
  signedIn(token, { 'Content-Type': 'application/json' })

/** A lazily loaded adapter call, carrying the caller's cancellation signal and response shape. */
export type V2Side = (token: string, init: RequestInit) => Promise<Response>

/** The header every answer a v2 side makes carries (v2.ts, `answer`), so a screen can tell which API answered. */
export const ANSWERED_BY = 'X-Answered-By'

/** Whether an adapted response carries the v2 marker. */
export const answeredByV2 = (response: Response) =>
  response.headers.get(ANSWERED_BY) === 'v2'

/** Read a named refusal's display text without consuming the caller's response body. */
export async function refusalWords(
  response: Response,
  status: number,
  code: string,
): Promise<string | null> {
  if (response.status !== status) return null
  try {
    const body = await response.clone().json()
    return body?.code === code && typeof body.error === 'string' && body.error
      ? body.error
      : null
  } catch {
    return null
  }
}
